import React, { useState } from "react"
import "./emailSignup.css"

const kitFormId = process.env.GATSBY_KIT_FORM_ID
const kitUserKey = "ckid"

const getKitUserId = () => {
  try {
    const existingId = window.localStorage.getItem(kitUserKey)

    if (existingId) {
      return existingId
    }

    const newId =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, char =>
            (
              Number(char) ^
              ((Math.random() * 16) >> (Number(char) / 4))
            ).toString(16)
          )
    window.localStorage.setItem(kitUserKey, newId)
    return newId
  } catch (error) {
    return ""
  }
}

const EmailSignup = () => {
  const [status, setStatus] = useState("idle")

  if (!kitFormId) {
    return null
  }

  const handleSubmit = async event => {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)

    formData.append("token", "")
    formData.append("referrer", document.referrer)
    formData.append("host", window.location.href)
    formData.append("search", window.location.search)
    formData.append("user", getKitUserId())
    formData.append("ckjs_version", "6")
    setStatus("submitting")

    try {
      const response = await fetch(
        `https://app.kit.com/forms/${kitFormId}/subscriptions`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-CKJS-Version": "6",
          },
          body: formData,
        }
      )
      const result = await response.json()

      if (!response.ok || result.status !== "success") {
        throw new Error("Kit rejected the subscription")
      }

      form.reset()
      setStatus("success")
    } catch (error) {
      setStatus("error")
    }
  }

  return (
    <section className="email-signup" aria-labelledby="email-signup-title">
      <div className="email-signup__copy">
        <h2 id="email-signup-title" className="no-curlys">
          Hear the next one first.
        </h2>
        <p>New music, sent only when there is something worth sharing.</p>
      </div>

      {status === "success" ? (
        <p className="email-signup__success" role="status">
          Thanks. Check your inbox for the next step.
        </p>
      ) : (
        <form
          className="email-signup__form"
          action={`https://app.kit.com/forms/${kitFormId}/subscriptions`}
          method="post"
          onSubmit={handleSubmit}
        >
          <label className="rv-visually-hidden" htmlFor="music-signup-email">
            Email address
          </label>
          <div className="email-signup__controls">
            <input
              id="music-signup-email"
              name="email_address"
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="you@example.com"
              required
              aria-describedby="email-signup-note email-signup-status"
            />
            <button type="submit" disabled={status === "submitting"}>
              {status === "submitting" ? "Joining..." : "Keep me posted"}
            </button>
          </div>
          <p id="email-signup-note" className="email-signup__note">
            No noise. Unsubscribe anytime.
          </p>
          <p
            id="email-signup-status"
            className="email-signup__status"
            role="status"
          >
            {status === "error"
              ? "That didn't go through. Please try again."
              : ""}
          </p>
        </form>
      )}
    </section>
  )
}

export default EmailSignup
